import { MsalInterceptorConfiguration, MsalGuardConfiguration } from '@azure/msal-angular';
import { IPublicClientApplication, PublicClientApplication, BrowserCacheLocation, LogLevel, InteractionType } from '@azure/msal-browser';

import { LoggingService } from '../services/logging.service';
import { SharedSettings } from '../models/shared-settings';
import { BrowserProviderService } from '@shared/services/browser-provider.service';

export function MsalInstanceFactory(
    logger: LoggingService,
    settings: SharedSettings,
    browser: BrowserProviderService
): IPublicClientApplication {
    const location = browser.GetLocation();
    const uri = location.origin + location.pathname + (location.pathname.endsWith('/') ? '' : '/');

    return new PublicClientApplication({
        auth: {
            clientId: settings.authClientId,
            authority: settings.authAuthority,
            redirectUri: uri,
            postLogoutRedirectUri: uri,
        },
        cache: {
            cacheLocation: BrowserCacheLocation.LocalStorage,
        },
        system: {
            loggerOptions: {
                piiLoggingEnabled: true,
                logLevel: LogLevel.Warning,
                loggerCallback: (level, message, _containsPii) => {
                    switch (level) {
                        case LogLevel.Error:
                            logger.error('MSAL Log', { message });
                            break;
                        case LogLevel.Warning:
                            logger.warning('MSAL Log', { message });
                            break;
                        default:
                            logger.info('MSAL Log', { message });
                    }
                },
            }
        }
    });
}

export function MsalInterceptorConfigFactory(settings: SharedSettings): MsalInterceptorConfiguration {
    return {
        interactionType: InteractionType.Redirect,
        protectedResourceMap: new Map([
            [settings.apiBaseUrl, settings.authScopes],
            [settings.oidenBaseUrl, settings.authScopes]
        ]),
    };
}

export function MsalGuardConfigFactory(settings: SharedSettings): MsalGuardConfiguration {
    return {
        interactionType: InteractionType.Redirect,
        loginFailedRoute: '/#/unauthorized',
        authRequest: {
            scopes: settings.authScopes,
        }
    };
}
